import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography
} from '@mui/material';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

export const EventDetailsCard = ({ orderData }) => {
  const participants =
    orderData.boys_count + orderData.girls_count;

  const paidGuardians =
    orderData.paid_guardian_woman_count +
    orderData.paid_guardian_man_count;

  const freeGuardians =
    orderData.free_guardian_woman_count +
    orderData.free_guardian_man_count;

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={5}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <EventOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
                  Szczegóły wyjazdu
          </Typography>
        </Stack>

        {/* TERMIN / MIEJSCE / PAKIET */}

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={8}
          mb={2}
        >
          <Box flex={1}>
            <Typography
              color="text.secondary"
              gutterBottom
            >
                    Termin
            </Typography>

            <Typography
              variant="h5"
              fontWeight={700}
            >
              {orderData.period_from} -{' '}
              {orderData.period_to}
            </Typography>
          </Box>

          <Box flex={1}>
            <Typography
              color="text.secondary"
              gutterBottom
            >
                    Miejsce
            </Typography>

            <Typography
              variant="h5"
              fontWeight={700}
            >
              {orderData.resort_name}
            </Typography>
          </Box>

          <Box flex={1}>
            <Typography
              color="text.secondary"
              gutterBottom
            >
                    Pakiet
            </Typography>

            <Typography
              variant="h5"
              fontWeight={700}
            >
              {orderData.package_display || '-'}
            </Typography>
          </Box>
        </Stack>

        {/* UCZESTNICY */}

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          mb={5}
        >
          <Box flex={1}>
            <Card
              variant="outlined"
              sx={{ borderRadius: 3 }}
            >
              <CardContent>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 2,
                      bgcolor:
                              'primary.lighter',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent:
                              'center'
                    }}
                  >
                    <GroupOutlinedIcon color="primary" />
                  </Box>

                  <Box>
                    <Typography color="text.secondary">
                            Uczestnicy
                    </Typography>

                    <Typography
                      variant="h4"
                      fontWeight={700}
                    >
                      {participants}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Box>

          <Box flex={1}>
            <Card
              variant="outlined"
              sx={{ borderRadius: 3 }}
            >
              <CardContent>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 2,
                      bgcolor:
                              'success.lighter',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent:
                              'center'
                    }}
                  >
                    <PersonOutlineOutlinedIcon color="success" />
                  </Box>

                  <Box>
                    <Typography color="text.secondary">
                            Opiekunowie płatni
                    </Typography>

                    <Typography
                      variant="h4"
                      fontWeight={700}
                    >
                      {paidGuardians}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Box>

          <Box flex={1}>
            <Card
              variant="outlined"
              sx={{ borderRadius: 3 }}
            >
              <CardContent>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 2,
                      bgcolor:
                              'warning.lighter',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent:
                              'center'
                    }}
                  >
                    <PersonOutlineOutlinedIcon color="warning" />
                  </Box>

                  <Box>
                    <Typography color="text.secondary">
                            Opiekunowie darmowi
                    </Typography>

                    <Typography
                      variant="h4"
                      fontWeight={700}
                    >
                      {freeGuardians}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Box>
        </Stack>

        {/* ZAJĘCIA */}
        <Divider />

        <Box mb={2} mt={2}>
          <Typography
            mt={2}
            mb={2}
            variant="h5"
            fontWeight={700}
          >
            Zajęcia
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            useFlexGap
          >
            {orderData.activities.map(
              activity => (
                <Chip
                  key={activity.value}
                  label={activity.label}
                  sx={{
                    borderRadius: 10
                  }}
                />
              )
            )}
          </Stack>
        </Box>

        {/* Dane Kontaktowe */}
        <Divider />

        <Box mt={2}>
          <Typography
            mb={3}
            variant="h5"
            fontWeight={700}
          >
            Dane Kontaktowe
          </Typography>

          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
          >
            {/* Dane dyrekcji */}
            <Box
              flex={1}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: 'action.hover'
              }}
            >
              <Typography
                mb={3}
                variant="h6"
                fontWeight={700}
              >
                Dane dyrekcji
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                mb={0.5}
              >
                Imię i nazwisko
              </Typography>

              <Typography
                variant="h6"
                fontWeight={700}
              >
                {[
                  orderData.agreement_signer_name,
                  orderData.agreement_signer_surname
                ]
                  .filter(Boolean)
                  .join(' ') || '-'}
              </Typography>
            </Box>

            {/* Osoba reprezentująca szkołę */}
            <Box
              flex={3}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: 'action.hover'
              }}
            >
              <Typography
                mb={3}
                variant="h6"
                fontWeight={700}
              >
                Osoba reprezentująca szkołę
              </Typography>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={4}
              >
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    mb={0.5}
                  >
                    Imię i nazwisko
                  </Typography>

                  <Typography variant="h6" fontWeight={700}>
                    {[
                      orderData.office_representative_name,
                      orderData.office_representative_surname
                    ]
                      .filter(Boolean)
                      .join(' ') || '-'}
                  </Typography>
                </Box>

                <Box flex={1}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    mb={0.5}
                  >
                    Telefon
                  </Typography>

                  <Typography variant="h6" fontWeight={700}>
                    {orderData.office_representative_phone || '-'}
                  </Typography>
                </Box>

                <Box flex={1}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    mb={0.5}
                  >
                    Dodatkowy telefon
                  </Typography>

                  <Typography variant="h6" fontWeight={700}>
                    {orderData.office_representative_additional_phone || '-'}
                  </Typography>
                </Box>

                <Box flex={1}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    mb={0.5}
                  >
                    E-mail
                  </Typography>

                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ wordBreak: 'break-word' }}
                  >
                    {orderData.office_representative_correspondence_email || '-'}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};
